<template>
    <section class="solution">
        <div class="container">
            <div class="grid" @mouseleave="resetActive">
                <div v-for="(it, i) in cards" :key="it.key" class="card" :class="{ active: i === activeIndex }"
                    @mouseenter="activeIndex = i" @click="goDetail(it.key)">
                    <div class="card-hd">
                        <div class="dot" aria-hidden="true"></div>
                        <div class="card-title">{{ it.title }}</div>
                    </div>

                    <div class="card-desc">{{ it.desc }}</div>

                    <span class="arrow" :class="{ active: i === activeIndex }" aria-hidden="true">
                        <svg viewBox="0 0 48 48" class="arrow-svg">
                            <circle cx="24" cy="24" r="20" fill="none" stroke="currentColor" stroke-width="2" />
                            <path d="M21 16 L29 24 L21 32" fill="none" stroke="currentColor" stroke-width="2.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
            </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const cards = [
    { key: "brand", title: "工业级激光定位灯（基础款）", desc: "核心定位：满足常规工业场景的精准定位需求，高性价比之选。" },
    { key: "trace", title: "智能激光视觉定位灯（进阶款）", desc: "核心定位：复杂场景高精度定位，支持智能联动，适配中高端工业智能化需求。" },
    { key: "code", title: " 防爆型耐高温定位灯（特种款）", desc: "核心定位：极端环境专属，具备防爆、耐高温、抗强震特性。" },
    { key: "channel", title: " 定制化定位灯（专属款）", desc: "核心定位：针对特殊行业、特殊设备的个性化定位需求，提供定制化研发生产服务。" },
    { key: "marketing", title: "双重定位技术，精度再升级", desc: "采用“激光定位+视觉校准”双重核心技术，突破传统单一定位方式的精度局限" },
    { key: "insight", title: "耐用性拉满", desc: "外壳采用高强度铝合金材质，经过阳极氧化处理，耐腐蚀、抗冲击" },
];

function goDetail(key) {
    router.push({ name: "productService", query: { key } });
}

const activeIndex = ref(-1); // ✅ 默认高亮第一个（进入页面时）
function resetActive() {
    activeIndex.value = -1; // ✅ 离开网格恢复第一个
}
</script>

<style scoped>
.solution {
    padding: 0;
    background: #fff;
}

.container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0;
}

.title {
    margin: 0;
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    letter-spacing: 1px;
    color: #1c1c1c;
}

.subtitle {
    margin: 14px auto 0;
    text-align: center;
    max-width: 920px;
    color: #666;
    line-height: 1.8;
    font-size: 15px;
}

.grid {
    margin-top: 34px;
    border: 1px solid #eee;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.card {
    position: relative;
    min-height: 220px;
    padding: 32px 34px 46px;
    background: #fff;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: transform .18s ease, box-shadow .18s ease, background-color .18s ease;
}

.card:nth-child(3n) {
    border-right: none;
}

.card:nth-last-child(-n + 3) {
    border-bottom: none;
}

.card-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: #0c5aa6;
}

.card-desc {
    margin: 14px 0 0;
    color: #666;
    line-height: 1.8;
    font-size: 14px;
    max-width: 92%;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.08);
    z-index: 2;
}

/* 高亮卡片（左上角那块蓝底） */
.card.active {
    background: linear-gradient(135deg, #0b66bb, #0a4f93);
    color: #fff;
    overflow: hidden;
}

.card.active::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 85% 30%, rgba(255, 255, 255, .18), transparent 40%),
        radial-gradient(circle at 70% 70%, rgba(255, 255, 255, .12), transparent 45%),
        radial-gradient(circle at 35% 55%, rgba(255, 255, 255, .10), transparent 48%);
    opacity: .9;
    pointer-events: none;
}

.card.active .card-title {
    color: #fff;
    position: relative;
}

.card.active .card-desc {
    color: rgba(255, 255, 255, 0.85);
    position: relative;
}

/* 左下角圆形箭头 */
.arrow {
    position: absolute;
    left: 28px;
    bottom: 22px;
    width: 40px;
    height: 40px;
    color: #a7a7a7;
}

.arrow-svg {
    width: 100%;
    height: 100%;
    display: block;
}

.arrow.active {
    color: rgba(255, 255, 255, 0.92);
}

/* 响应式 */
@media (max-width: 980px) {
    .grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .card:nth-child(3n) {
        border-right: 1px solid #eee;
    }

    .card:nth-child(2n) {
        border-right: none;
    }

    .card:nth-last-child(-n + 3) {
        border-bottom: 1px solid #eee;
    }

    .card:nth-last-child(-n + 2) {
        border-bottom: none;
    }
}

@media (max-width: 640px) {
    .solution {
        padding: 44px 0 10px;
    }

    .title {
        font-size: 26px;
    }

    .grid {
        grid-template-columns: 1fr;
    }

    .card {
        border-right: none !important;
    }

    .card {
        min-height: 200px;
        padding: 26px 22px 44px;
    }
}
</style>
